import React, { useState } from 'react';
import SharepointModal from '../SharepointModal';
import useSharepoint from '../../hooks/useSharepoint';
import styles from './sharepoint-panel.module.scss';
type Props = {
  orgID?: string;
};

const SharepointPanel = ({ orgID }: Props) => {
  const [modalTopic, setModalTopic] = useState<
    'instructions' | 'settings' | null
  >(null);
  const { summary, syncRuns, isFetchingSummary, isFetchingSyncs } =
    useSharepoint(orgID);

  // const handleClick = () => {
  //   if (isConnected) {
  //     setModalTopic('settings');
  //   } else {
  //     setModalTopic('instructions');
  //   }
  // };

  return (
    <div className={styles['sharepoint-panel']}>
      {/* <Button
        variation="secondary"
        className={styles['sharepoint-cta']}
        data-status={isConnected ? 'connected' : 'disconnected'}
        onClick={handleClick}
        loading={isFetchingSummary || isFetchingSyncs}
        loadingText="Checking..."
      >
        <SharepointIcon />
        {isConnected ? 'Sharepoint Settings' : 'Connect to SharePoint'}
      </Button> */}

      {modalTopic !== null && (
        <SharepointModal
          isOpen={modalTopic !== null}
          onClose={() => setModalTopic(null)}
          topic={modalTopic}
          summary={summary}
          syncRuns={syncRuns}
          isLoading={isFetchingSummary || isFetchingSyncs}
        />
      )}
    </div>
  );
};

export default SharepointPanel;
